export interface Customization {
  customizationImages: CustomizationImage[]
  printAreas: PrintArea[]
}

export interface CustomizationImage {
  viewId: ViewId
  url: string
  height: number
  width: number
}

export enum ViewId {
  FRONT = 'FRONT',
}

export interface PrintArea {
  type: string
  viewId: ViewId
  placementLabel: string
  dimensions: Dimensions
  coordinates: Coordinates
  methods: Method[]
}

export interface Dimensions {
  width: number
  height: number
  unit: Unit
}

export enum Unit {
  INCHES = 'INCHES',
}

export interface Coordinates {
  xPercentFromLeft: number
  yPercentFromTop: number
  widthPercent: number
  heightPercent: number
}

export interface Method {
  linkedVariantId: number
  name: string
  applicationFee: number
  maxColors: number
}
